class ToggleInfoCard {
    heightInnerCard

    constructor(el) {
        this.el = el;
        this.btnExpand = this.el.querySelector(".js-expand-info-card");
        this.btnCollapse = this.el.querySelector(".js-collapse-info-card");
        this.heightCard = this.el.clientHeight;
        this.innerCard = this.el.querySelector(".info-card__inner");
        this.btn = this.el.querySelector(".js-info-card-show-all");
        
        this.openButtonShowAll();
        this.listenEvents();
    }

    listenEvents() {
        this.btnExpand.addEventListener("click", () => {
            this.expandCard();

            document.querySelectorAll(".js-info-card").forEach(card => {
                if (card !== this.el && card.classList.contains("expand")) {
                    card.classList.remove("expand");
                }
            })
        });

        this.btnCollapse.addEventListener("click", () => {
            this.collapseCard();
            this.el.scrollIntoView({block: "start", behavior: "smooth"});
        });

        document.addEventListener("click", (e) => {
            const target = e.target;

            if (!target.classList.contains("js-info-card") && !target.closest(".js-info-card")) {
                this.collapseCard();
            }
        })
    }

    expandCard = () => {
        this.el.classList.add("expand");
    };

    collapseCard = () => {
        this.el.classList.remove("expand");
    }

    openButtonShowAll() {
        this.heightInnerCard = this.innerCard.clientHeight;

        if (this.heightInnerCard > this.heightCard) {
            this.btn.classList.remove("hidden");
        }
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-info-card")
        .forEach(card => new ToggleInfoCard(card));
});
